import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatLegacyTooltipModule as MatTooltipModule} from '@angular/material/legacy-tooltip';
import {IonicModule} from '@ionic/angular';
import {ViewGoalsModule} from 'src/app/dashboard/goals-progress/view-goals/view-goals.module';
import {PipesModule} from '../../pipes/pipes.module';
import {UtilService} from '../../services/util.service';
import {ConceptsDescriptionModalModule} from '../concepts-description/concepts-description-modal.module';
import {QuestionAnswerModule} from '../question-answer/question-answer.module';
import {QuestionTypesComponent} from './question-types.component';
import {BooleanQuestionsComponent} from './components/boolean-questions/boolean-questions.component';
import {CalculateQuestionsComponent} from './components/calculate-questions/calculate-questions.component';
import {DateQuestionsComponent} from './components/date-questions/date-questions.component';
import {GroupedSliderQuestionsComponent} from './components/grouped-slider-questions/grouped-slider-questions.component';
import {MultiSelectionQuestionsComponent} from './components/multi-selection-questions/multi-selection-questions.component';
import {NumberQuestionsComponent} from './components/number-questions/number-questions.component';
import {SelectionQuestionsComponent} from './components/selection-questions/selection-questions.component';
import {SliderQuestionsComponent} from './components/slider-questions/slider-questions.component';
import {TextQuestionsComponent} from './components/text-questions/text-questions.component';
import { TextAlertModalModule } from '../../modals/text-alert/text-alert-modal.module';

@NgModule({
    declarations: [
        QuestionTypesComponent,
        BooleanQuestionsComponent,
        CalculateQuestionsComponent,
        DateQuestionsComponent,
        GroupedSliderQuestionsComponent,
        MultiSelectionQuestionsComponent,
        NumberQuestionsComponent,
        SelectionQuestionsComponent,
        SliderQuestionsComponent,
        TextQuestionsComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        PipesModule,
        QuestionAnswerModule,
        ViewGoalsModule,
        MatTooltipModule,
        ConceptsDescriptionModalModule,
        TextAlertModalModule
    ],
    exports: [
        QuestionTypesComponent
    ],
    providers: [
        UtilService
    ]
})
export class QuestionTypesModule {
}
